<div [formGroup]="codeForm" class="code-input">
    <input
        #digitInput
        *ngFor="let digit of digits; let i = index"
        type="text"
        formControlName="digit{{ i }}"
        maxlength="1"
        (input)="moveFocus($event, i)"
        (focus)="clearInput(i)"
    />
</div>
